import { c as _c } from "react/compiler-runtime";
import throttle from "lodash-es/throttle";
import { useEffect, useState } from "react";
export const useHeaderWrapper = () => {
  const $ = _c(5);
  const [scrolled, setScrolled] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const onScroll = () => {
        setScrolled(window.scrollY > 0);
      };
      const onScrollThrottle = throttle(onScroll, 100);
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", onScrollThrottle);
      }
      return () => {
        if (typeof window !== "undefined") {
          window.removeEventListener("scroll", onScrollThrottle);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== scrolled) {
    t3 = {
      scrolled,
      headerProperties: t2
    };
    $[3] = scrolled;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};